import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const getDepartmentById = (departmentId) => {
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const response = await axios.get(
        `${FIRMFLOWURL}api/Department/${departmentId}`,
        {
          headers: { Authorization: token },
        }
      );
      console.log("respuesta: ", response);
      resolve({ ...response, success: true });
    } catch (err) {
      console.log("error on fetching department", err);
      const status = err.response?.status;
      if (status === 401 || err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      resolve({
        success: false,
        status,
        message: err.response?.data?.message || err.message,
      });
    }
  });
};
